import "./App.css";
import { Routes, Route } from "react-router-dom";
import { Home, Pomodoro, NotFound, Login, Signup, Logout } from "./pages";

function App() {
  return (
    <div className="App">
      <Routes>
        <Route path="/home" element={<Home />} />
        <Route path="/pomodoro/:id" element={<Pomodoro />} />
        <Route path="/" element={<Login />} />
        <Route path="/Signup" element={<Signup />} />
        <Route path="/Logout" element={<Logout />} />
        <Route path="*" element={<NotFound />} />
      </Routes>
    </div>
  );
}

export default App;
